import React from "react";
import { languages } from "../../constants/languages";
import moment from "moment-timezone";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";

export const Messages = props => (
  <div>
    {props.messages.map(message => {
      return (
        <Paper
          key={message[".key"]}
          style={{ padding: "30px 35px 30px", lineHeight: 1.6, marginBottom: 20 }}
        >
          {message.message}
          <br />
          <div
            style={{
              color: "gray",
              fontSize: 13,
              marginTop: 10,
              display: "flex",
              alignItems: "center"
            }}
          >
            {props.admins.indexOf(message.uid) !== -1 && (
              <CheckCircleIcon color="primary" style={{ height: 17 }} />
            )}
            {(message.name || "") +
              " - " +
              moment.unix(message.date).format(languages.features.dateFormat)}
            {props.isAdmin && (
              <DeleteIcon
                color={
                  props.deleteConfirm === message[".key"]
                    ? "secondary"
                    : "inherit"
                }
                style={{ height: 17, cursor: "pointer" }}
                onClick={e => {
                  props.handleDelete(e, message[".key"]);
                }}
              />
            )}
          </div>
        </Paper>
      );
    })}
    <Paper style={{ padding: "30px 35px 75px" }}>
      <div style={{ fontWeight: 600 }}>{languages.features.addComment}</div>
      <br />
      <TextField
        variant="outlined"
        multiline
        rows="2"
        fullWidth
        name="message"
        value={props.message}
        onChange={props.handleChange}
        placeholder={languages.features.comment}
      />
      <br />
      <br />
      <TextField
        variant="outlined"
        fullWidth
        name="name"
        value={props.name}
        onChange={props.handleChange}
        placeholder={languages.features.whatsYourName}
      />
      <Button
        variant="outlined"
        color="default"
        size="small"
        onClick={props.handleSubmitMessage}
        disabled={
          props.message.trim().length === 0 || props.name.trim().length === 0
        }
        style={{ float: "right", marginTop: 10 }}
      >
        {languages.features.addComment2}
      </Button>
    </Paper>
  </div>
);
